<template>
  <div class="candidate-apply p-l-15 p-r-15 p-t-15">
    <div class="row">

      <div v-if="candidateEntityDeleted" class="m-l-0 col-12 row p-t-30 p-b-20 candidate-card">

        <div class="col-12 p-b-25 offer-data-block">
          <span class="font-weight-bold"><i class="fa fa-exclamation-triangle m-r-10"></i>{{ $t('Offer.deleted_candidate') }}</span>
        </div>

        <div class="col-12 p-b-15 offer-data-block">
          <span class="offer-data">
            <i class="fa fa-user m-r-10"></i>
            {{ candidateFullName }}
          </span>
        </div>

        <div class="col-12 p-b-15 offer-data-block">
          <span class="offer-data">
            <i class="fa fa-phone m-r-10"></i>
            {{ candidateInfo.phone_display }}
          </span>
        </div>

        <div class="col-12 p-b-15 offer-data-block">
          <span class="offer-data">
            <i class="fa fa-envelope m-r-5"></i>
            {{ candidateInfo.email }}
          </span>
        </div>

      </div>

      <div v-else class="m-l-0 col-12 row p-t-30 p-b-30 candidate-card">

        <div class="col-md-4">

          <div class="col-12 p-b-15 offer-data-block">
            <span class="offer-data">
              <i class="fa fa-user m-r-10"></i>
              <router-link :to="candidateEditPage" target="_blank">
                {{ candidateFullName }}
              </router-link>
            </span>
          </div>

          <div class="col-12 p-b-15 offer-data-block">
            <span>
              <i class="fa fa-user-md m-r-5"></i>
              <span class="multiselect__tag tag-without-close m-b-0" v-for="occupation in candidateInfo.occupations"> {{ occupation.name }}</span>
            </span>
          </div>

          <div class="col-12 p-b-15 offer-data-block">
            <span class="offer-data">
              <i class="fa fa-phone m-r-10"></i>
              {{ candidateInfo.phone_display }}
            </span>
          </div>
          <div class="col-12 p-b-15 offer-data-block">
            <span class="offer-data">
              <i class="fa fa-envelope m-r-5"></i>
              {{ candidateInfo.email }}
            </span>
          </div>

          <div class="col-12 p-b-15 offer-data-block">
            <span v-show="candidateInfo.resource_type == 'extern'">
              <span class="offer-data">
                <i class="icon-size pg-map m-r-5"></i>
                <span class="extern_tag tag-without-close m-b-0">
                  {{ $t('models.resource_type.extern') }}
                  <span class="bg-transparent" v-html="externalExtra" />
                </span>
              </span>
            </span>
            <div class="intern-service-wrapper" v-if="candidateInfo.resource_type == 'intern'">
              <span class="offer-data">
                <i class="icon-size pg-map m-r-5"></i>
                <span class="intern_tag tag-without-close m-b-0 m-l-10">
                  {{ $t('models.resource_type.intern') }} : {{ candidateAffiliatedService }}
                </span>
              </span>

            </div>
          </div>
        </div>

        <div class="col-md-4" style="position: relative; border-left: 1px solid black; text-align: center;">
          <span class="offer-data-icon m-r-5">
            <p v-if="offerStartInCurrentMonth"> {{ $i18n.t('OfferCandidateInfo.this_month') }} : </p>
            <p v-else>{{ $i18n.t('OfferCandidateInfo.at_the_month_of') }}{{ monthOfOfferStart }} :</p>

            <p>
              {{ unavailabilityDateCountFuture }} {{ unavailabilityDateCountFuture <= 1 ? $i18n.t('OfferCandidateInfo.future_offer') : $i18n.t('OfferCandidateInfo.future_offers') }}

              <span v-if="effectiveWorkMinutesFuture > 0">
                ({{$i18n.t('OfferCandidateInfo.that_is')}} <b>{{effectiveWorkFuture}}</b>)
                <a v-if="!effectiveWorkMinutesAllFilledFuture"
                   :title="$i18n.t('OfferCandidateInfo.effective_work_not_complete')">
                  <i class="fa fa-exclamation-triangle"></i>
                </a>
              </span>
            </p>

            <p v-if="offerStartInCurrentMonth">
              {{ unavailabilityDateCountPassed }} {{ unavailabilityDateCountPassed <= 1 ? $i18n.t('OfferCandidateInfo.passed_offer') : $i18n.t('OfferCandidateInfo.passed_offers') }}

              <span v-if="effectiveWorkMinutesPassed > 0">
                ({{$i18n.t('OfferCandidateInfo.that_is')}} <b>{{effectiveWorkPassed}}</b>)
                <a v-if="!effectiveWorkMinutesAllFilledPassed"
                   :title="$i18n.t('OfferCandidateInfo.effective_work_not_complete')">
                  <i class="fa fa-exclamation-triangle"></i>
                </a>
              </span>
            </p>
            <router-link class="btn btn-primary btn-cons m-t-10" :to="displayCandidateHistoric" target="_blank">
              {{ $t("Offer.see_historic") }}
            </router-link>
          </span>
        </div>

        <div class="col-md-4" style="position: relative; border-left: 1px solid black;">

          <div class="col-12 p-b-15 offer-data-block" style="padding: 50px">
            <span>
              <div v-if="displayAcceptDeclineBtn">
                <button id="accept-button" class="btn btn-primary btn-cons m-t-10" @click="accept" style="width: 100%;">{{ $t("Offer.accept") }}</button>
                <button class="btn btn-default btn-cons m-t-10" @click="decline" style="width: 100%;">{{ $t("Offer.decline") }}</button>
              </div>
              <div v-if="candidateValidated">
                <h4><i style="color:green" class="fa fa-check-circle-o"></i> {{ $i18n.t('OfferCandidateInfo.candidated_validated') }}</h4>
              </div>
               <div v-if="candidateCancelled">
                <h4><img src="../../assets/img/pages/icons/icons8-cancel-96.png" width="30" height="30"/> {{ $i18n.t('OfferCandidateInfo.candidated_cancelled') }}</h4>
              </div>
            </span>
          </div>
          <div class="d-flex flex-column align-items-end">
            <span class="offer-apply-datetime">
              {{ $t("OfferCandidateInfo.accept_at", { date_time: appliedAt }) }}
            </span>
            <span v-if="validator" class="offer-apply-datetime">
              {{ $t("OfferCandidateInfo.validated_by", { validator: validator }) }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import { mapGetters, mapActions } from 'vuex'
  import { offerStatus } from '@/settings/offers'
  import moment from 'moment'
  import { convertMinutesToDurationTime } from '@/helpers/timeCodes'
  import AtInternetManager from '@/helpers/at_internet/manage_requests'

  export default {
    name: 'OfferCandidateInfo',
    props: ['appliedCandidate', 'offerStatus', 'offerId', 'entityId', 'validator', 'offerStartAt'],
    data() {
      return {
        unavailabilityDateCountPassed: 0,
        effectiveWorkMinutesPassed: 0,
        effectiveWorkMinutesAllFilledPassed: true,
        unavailabilityDateCountFuture: 0,
        effectiveWorkMinutesFuture: 0,
        effectiveWorkMinutesAllFilledFuture: true,
      }
    },
    computed: {
      ...mapGetters({
        offer: 'offers/offer',
      }),
      candidateInfo(){
        return this.appliedCandidate.user_info
      },
      candidateFullName() {
        return `${this.candidateInfo.first_name} ${this.candidateInfo.last_name}`
      },
      displayAcceptDeclineBtn() {
        return this.offerStatus == offerStatus.waiting
      },
      candidateValidated() {
        return this.offerStatus == offerStatus.validated
      },
      candidateCancelled() {
        return this.offerStatus == offerStatus.cancelled
      },
      candidateEntityDeleted() {
        return !this.appliedCandidate.user_info.entities.some(element => element.id == this.entityId)
      },
      appliedAt() {
        return this.$options.filters.formatDateAtTime(this.appliedCandidate.applied_at)
      },
      offerStartInCurrentMonth() {
        return moment(this.offerStartAt).format('M') == moment().format('M')
      },
      monthOfOfferStart() {
        return moment(this.offerStartAt).locale('fr').format('MMMM')
      },
      filter_params(){
        return {
          start_at_gt: moment().startOf('month').format(this.$i18n.t('format.date')),
          end_at_lt: moment().endOf('month').format(this.$i18n.t('format.date'))
        }
      },
      displayCandidateHistoric: function() {
        return {
          name: "CandidatePlanning",
          params: { entity_id: this.entityId, user_id: this.appliedCandidate.user_info.id }
        }
      },
      candidateEditPage() {
        return {
          name: "EditUser",
          params: { entity_id: this.entityId, user_id: this.appliedCandidate.user_info.id }
        }
      },
      externalExtra() {
        let userEntities = [ ...this.appliedCandidate.user_info.user_entities ]
        const corporationId = userEntities.find(ue => ue.entity.id == this.entityId).entity.corporation.id

        userEntities = userEntities.filter(
          (ue) =>
            ue.entity.id != this.entityId &&
            ue.entity.corporation.id == corporationId &&
            ue.resource_type == 'intern' &&
            ue.aasm_state == 'active'
        )
        let extra = ''
        if (userEntities.length > 0) {
          const defaultEntity = userEntities[0].entity.name
          const otherCount = userEntities.length - 1
          extra = this.$tc('OfferCandidateInfo.external_extra', otherCount, { entity: defaultEntity, count: otherCount })
        }
        return extra
      },

      candidateAffiliatedService() {
        const affiliatedServiceName = this.candidateInfo.affiliated_service.name
        const hubName = this.candidateInfo.affiliated_service.hub_name
        if (hubName != null) {
          return `${affiliatedServiceName} (${hubName})`
        }
        return affiliatedServiceName
      },
      effectiveWorkPassed(){
        return convertMinutesToDurationTime(this.effectiveWorkMinutesPassed, false)
      },
      effectiveWorkFuture(){
        return convertMinutesToDurationTime(this.effectiveWorkMinutesFuture, false)
      }
    },
    methods: {
      ...mapActions({
        loadUnavailabilityDateCount: 'unavailabilityDates/loadUnavailabilityDateCount',
      }),
      decline: function(dialog) {
        var self = this
        this.$dialog.confirm(this.$i18n.t('OfferCandidateInfo.decline_confirmation'))
        .then(function () {
          AtInternetManager.sendNumberApplicantsRefusedtEvent()
          self.$store.dispatch('offers/declineOffer', { offerId: self.offerId , userAppliedOfferId: self.appliedCandidate.id });
        })
        .catch(function () {})
      },
      accept: function() {
        this.$store.dispatch('offers/acceptOffer', { offerId: this.offerId , userAppliedOfferId: this.appliedCandidate.id });
      },
      getUnavailabilityDatesCount: async function() {
        const filters = {
          start_at_gt: moment(this.offerStartAt).startOf('month').format(this.$i18n.t('format.date')),
          end_at_lt: moment(this.offerStartAt).endOf('month').format(this.$i18n.t('format.date'))
        }

        const unavailabilityDateCount = await this.loadUnavailabilityDateCount({ userId: this.appliedCandidate.user_info.id, params: filters })
        this.unavailabilityDateCountPassed = unavailabilityDateCount.passed_count
        this.effectiveWorkMinutesPassed = unavailabilityDateCount.passed_effective_work_minutes
        this.effectiveWorkMinutesAllFilledPassed = unavailabilityDateCount.passed_effective_work_minutes_all_filled
        this.unavailabilityDateCountFuture = unavailabilityDateCount.future_count
        this.effectiveWorkMinutesFuture = unavailabilityDateCount.future_effective_work_minutes
        this.effectiveWorkMinutesAllFilledFuture = unavailabilityDateCount.future_effective_work_minutes_all_filled
      }
    },
    watch: {
      offerStartAt: function() {
        this.getUnavailabilityDatesCount()
      }
    },
    mounted: function() {
      this.getUnavailabilityDatesCount()
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../assets/scss/pages/_var.scss';

  .offer-apply-datetime {
    font-size: 11px;
    opacity: 0.7;
  }

  .offer-data-block {
    display: -webkit-inline-box;
  }

  .offer-data-block .fa {
    font-size: 20px;
  }

  .offer-information {
    border-bottom: 1px solid #dadee0;
  }

  .offer-data {
    display: inherit;
    border: none !important;
  }

  .offer-data span {
    background-color: #F51153;
    display: inline-block;
  }

  .icon-size {
    font-size: 20px;
  }

  .tag-without-close{
    white-space: normal;
    max-width: 90%;
  }
</style>



// WEBPACK FOOTER //
// src/components/offers/OfferCandidateInfo.vue